import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { CreateProduct } from '../types/types'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetProductsQuery = (isEnabled = true) => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['products'],
    enabled: isEnabled,
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/products')
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

export const useCreateProductMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (product: CreateProduct) => {
      const { data, error } = await authFetch().POST('/products', {
        body: product
      })
      if (error) {
        throwOnError(error)
      }
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['products']
      })
    }
  })
}

export const useDeleteProductMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (productId: number) =>
      await authFetch().DELETE('/products/{productId}', {
        params: {
          path: { productId }
        }
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['products']
      })
    }
  })
}
